import * as R from 'ramda'
import { t } from 'ttag'

import {
  TAB_NAMES as REPORT_TAB_NAMES,
  getFactors,
} from 'components/modals/TestsReportModal/model'

/** Main modal tabs (distinct from REPORT_TAB_NAMES.OVERVIEW used inside PersonalityFactors). */
export const TAB_NAMES = {
  OVERVIEW: 'jobseeker-results-overview',
  PERSONALITY: REPORT_TAB_NAMES.PERSONALITY,
}

export const getTabs = () => [
  { id: TAB_NAMES.OVERVIEW, label: t`Talent overview` },
  { id: TAB_NAMES.PERSONALITY, label: t`Personality` },
]

/** Same factor list as a single recruitment candidate, with job-seeker neuroticism facet. */
export const getJobSeekerPersonalityFactors = () =>
  R.filter(
    R.propEq('parentId', REPORT_TAB_NAMES.PERSONALITY),
    getFactors(true, true),
  )
